/**
 * A callable request body without its valueless keys.
 *
 * WHY. The Firebase callable client cannot send `undefined`: it encodes a key whose value is undefined as `null`
 * (@firebase/functions encode(): `if (data == null) return null`). A server that reads an optional field as
 * "absent or a string" then refuses the null. That refused every drag on the Issue Triage board (TRIAGE-BOARD-400,
 * 17 of 17 moves in 30 days: `notes: null` -> "notes must be a string"). Leaving the key out sends what was meant.
 * Only `undefined` is dropped: null, "" and false are values and are sent as they are.
 */
export function definedFields<T extends Record<string, unknown>>(body: T): Partial<T> {
  return Object.fromEntries(Object.entries(body).filter(([, v]) => v !== undefined)) as Partial<T>;
}
